import SubjectAccordion, { SubjectAccordionProps } from './SubjectAccordion';
export default SubjectAccordion;
export type { SubjectAccordionProps };
